import { has } from "lodash";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppState } from "../../context";
import Login from "./Login";
import NewPassword from "./NewPassword";
import OtpForm from "./OtpForm";

const Auth = ({ type }: { type: string }) => {
  const navigate = useNavigate();
  const { isLoggedIn, userData, logout } = useAppState("auth");

  const [, setStep] = useState(type);

  useEffect(() => {
    setStep(type);
  }, [type]);

  useEffect(() => {
    logout();
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      if (has(userData, "role_name")) {
        navigate("/dashboard");
      }
    }
  }, [isLoggedIn]);

  const RenderComponent = ({ screenId }: { screenId: string }) => {
    let result = <></>;
    switch (screenId) {
      case "1":
        result = <Login />;
        break;

      case "2":
        result = <OtpForm />;
        break;

      case "3":
        result = <NewPassword />;
        break;

      default:
        break;
    }

    return result;
  };

  return (
    <div className="">
      <div className="flex h-lvh ">
        <div className="relative w-full mx-auto flex flex-col justify-center">
          <div>
            <RenderComponent screenId={type} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Auth;
